import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=648f152c&scoped=true&"
import script from "./coupon.js?vue&type=script&lang=js&"
export * from "./coupon.js?vue&type=script&lang=js&"
import style0 from "./coupon.scss?vue&type=style&index=0&id=648f152c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f152c",
  null
  
)

export default component.exports